<div class="modal-content">
  <div class="modal-header">
    <h4>Előnézet</h4>
  </div>
  <div class="modal-body" id="pdf-preview-container">
    <div #insertedHtml [innerHTML]="this.content"></div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark me-auto" (click)="close()">Mégse</button>
    <button type="button" class="btn btn-primary text-white" (click)="save()">
      <span class="material-icons me-1">save</span>
      Mentés
    </button>
    <button type="button" class="btn btn-primary text-white" (click)="print()">
      <span class="material-icons me-1">print</span>
      Nyomtatás
    </button>
  </div>
</div>
